import BaseApi from "@/core/HttpResources/BaseApi";
export default class EvaluacionService {

    async getById(id: number): Promise<any> {
      var baseApi = new BaseApi("Evaluacion/" +id);
      return new Promise<any>((resolve, reject) =>
          baseApi.request(
          "GET",
          String(),
          {},
          {},
          response => resolve(response.data),
          reject,
          () => {}
        )
      );
    }

    async update(model: any): Promise<Array<any>> {
        var baseApi = new BaseApi("Evaluacion/" + model.id);
        return new Promise<Array<any>>((resolve, reject) =>
            baseApi.request(
            "PUT",
            String(),
            model,
            {},
            response => resolve(response.data),
            reject,
            () => {}
            )
        );
    }

    async save(model: any): Promise<Array<any>> {
        var baseApi = new BaseApi("Evaluacion");
        return new Promise<Array<any>>((resolve, reject) =>
        baseApi.request(
            "POST",
            String(),
            model,
            {},
            response => resolve(response.data),
            reject,
            () => {}
        )
        );
    }

  async getByUserAndProposalId(userId: number, proposalId: number, evaluationTypeId: number) {
    var baseApi = new BaseApi("Evaluacion/GetByUserId/"+userId+"/ProposalId/" + proposalId + "/EvaluationType/" + evaluationTypeId);
    return new Promise<any>((resolve, reject) =>
      baseApi.request(
        "GET",
        String(),
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

}